import { useMutation } from "@apollo/client";
import { Button, Drawer, Form } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { CREATE_LEAD, UPDATE_LEAD_V2 } from "../../../graphql/mutation";
import useCrmIntegration from "../../../hooks/useCrmIntegration";
import { getMobileView } from "../../../redux/slices/isMobile";
import LeadEditModal from "../leadEditModal";

const LeadEditDrawer = props => {
  const crmIntegration = useCrmIntegration();
  const isMobileView = useSelector(state => getMobileView(state));
  const { drawerData, setDrawerData } = props;
  const onClose = () => {
    setDrawerData({ open: false });
  };
  const [profileForm] = Form.useForm();
  const [form] = Form.useForm();
  const [createLead, { loading: createLoader }] = useMutation(CREATE_LEAD);
  const [updateLead, { loading: updateLoader }] = useMutation(UPDATE_LEAD_V2);
  return (
    <Drawer
      className="normal-popup"
      title={drawerData.header}
      width={isMobileView ? "100%" : drawerData.width ?? "40%"}
      open={drawerData.open}
      onClose={onClose}
      footer={
        <div className="flex-row-centered gap-1">
          <Button
            loading={createLoader || updateLoader}
            onClick={() => {
              drawerData.mode === "EDIT" ? profileForm.submit() : form.submit();
            }}
            type="primary"
          >
            Save
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      }
    >
      <LeadEditModal
        onClose={onClose}
        createLead={createLead}
        updateLead={updateLead}
        createLoader={createLoader}
        updateLoader={updateLoader}
        profileForm={drawerData.mode === "EDIT" ? profileForm : form}
        form={form}
        lead={drawerData.lead}
        refetch={drawerData.refetch}
        refetchLeads={drawerData.refetchLeads}
        getLeads={drawerData.getLeads}
        refetchLeadOpportunities={drawerData.refetchLeadOpportunities}
        crmIntegration={crmIntegration}
        mode={drawerData.mode}
        setSelectedLead={drawerData.setSelectedLead}
        setLeadList={drawerData.setLeadList}
        showOpportunityForm={drawerData.showOpportunityForm ?? true}
      />
    </Drawer>
  );
};

export default LeadEditDrawer;
